import DodoneShowGenericWrapper from 'app/dodones/generic/show/Wrapper'

export default DodoneShowGenericWrapper
